import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import { Button } from './button';

export function Pagination({
  page,
  totalPages,
  totalCount,
  pageSize,
  onChange,
  label = 'items'
}: {
  page: number;
  totalPages: number;
  totalCount: number;
  pageSize: number;
  onChange: (page: number) => void;
  label?: string;
}) {
  if (totalPages <= 1) {
    return totalCount > 0 ? (
      <div className="flex items-center justify-between border-t border-[var(--line)] px-4 py-3 text-sm text-muted">
        <span className="tnum">
          {totalCount} {label}
        </span>
      </div>
    ) : null;
  }

  const first = (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, totalCount);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-[var(--line)] px-4 py-3">
      <p className="tnum text-sm text-muted">
        {first}–{last} of {totalCount} {label}
      </p>
      <div className="flex items-center gap-1">
        <Button
          variant="ghost"
          size="iconSm"
          aria-label="First page"
          disabled={page <= 1}
          onClick={() => onChange(1)}
        >
          <ChevronsLeft />
        </Button>
        <Button
          variant="ghost"
          size="iconSm"
          aria-label="Previous page"
          disabled={page <= 1}
          onClick={() => onChange(page - 1)}
        >
          <ChevronLeft />
        </Button>
        <span className="tnum px-2 text-sm text-muted">
          {page} / {totalPages}
        </span>
        <Button
          variant="ghost"
          size="iconSm"
          aria-label="Next page"
          disabled={page >= totalPages}
          onClick={() => onChange(page + 1)}
        >
          <ChevronRight />
        </Button>
        <Button
          variant="ghost"
          size="iconSm"
          aria-label="Last page"
          disabled={page >= totalPages}
          onClick={() => onChange(totalPages)}
        >
          <ChevronsRight />
        </Button>
      </div>
    </div>
  );
}
